
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AcceleratorSection() {
  const features = [
    {
      icon: 'ri-rocket-line',
      title: 'Mini-funnel de conversion',
      description: 'Landing page + page de remerciement optimisées pour capturer vos premiers leads'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Plan 30 jours',
      description: 'Stratégie complète pour obtenir vos premiers clients rapidement'
    },
    {
      icon: 'ri-mail-send-line',
      title: 'Séquence email en 3 messages',
      description: 'Automatisation pour nourrir vos leads et les convertir'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-yellow-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-flashlight-line"></i>
            <span>Option premium</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Accélérateur <span className="text-yellow-700">First Clients Fast™</span>
          </h2>
          <p className="text-2xl text-slate-700 max-w-4xl mx-auto font-medium mb-4">
            Vous ne repartez pas qu'avec un site :<br />
            vous repartez avec une machine à obtenir vos premiers clients.
          </p>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Un système complet pour générer des leads qualifiés dès les premières semaines
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-yellow-100"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-yellow-600 to-yellow-700 rounded-xl mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/accelerateur">
            <Button size="lg">
              Découvrir l'accélérateur
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
